import './input.css'

export const Input = (props)=>{
    return(
       <input
        className='form-input'
        {...props}
       /> 
    )
}